import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
  providedIn: 'root'
})
export class FileService extends BaseService {
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService,
              public fileUploadService: UploadService) {
    super(http, alertService, globalService);
  }

  fileUpload(params: any, event: any): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
  }

  chatsFileUpload(params: any, event: any): Observable<any> {
    return this.fileUploadService.makeMultipleFileRequest(event, AppUrl.CHATS_FILE_UPLOAD(), params);
  }

  // Direct-to-S3 chat attachment uploads (up to 1GB) -- these three are
  // plain JSON calls to Laravel; the actual file bytes never pass through
  // this service, they go straight to S3 via UploadService.uploadDirectToS3
  // using the presigned URL(s) these return. See FileRepository::
  // initiateMessageFileUpload/completeMessageFileUpload/abortMessageFileUpload.
  initiateMessageFileUpload(data: { filename: string; size: number; mime_type: string; chat_type: 'PRIVATE_MESSAGE' | 'GROUP_MESSAGE' }): Observable<any> {
    return this.postRequest(AppUrl.MESSAGE_FILE_UPLOAD_INITIATE(), data);
  }

  completeMessageFileUpload(data: { id: number; upload_id?: string; parts?: { part_number: number; etag: string }[] }): Observable<any> {
    return this.postRequest(AppUrl.MESSAGE_FILE_UPLOAD_COMPLETE(), data);
  }

  abortMessageFileUpload(data: { id: number }): Observable<any> {
    return this.postRequest(AppUrl.MESSAGE_FILE_UPLOAD_ABORT(), data);
  }

  groupProfileUpload(params: any, event: any): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.CHATS_FILE_UPLOAD(), params, event);
  }

  singleFileUpload(data: {}, event: any): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.SINGLE_FILE_UPLOAD(), data, event);
  }

  fileMultipleUpload(data: {}, event: any): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.MULTIPLE_FILE_UPLOAD(), data, event);
  }

  deviceFileUpload(params: any, file: File): Observable<any> {
    return this.fileUploadService.makeMultipleFileRequest(file, AppUrl.FILE_UPLOAD(), params);
  }

  updateProfileLogo(data: {}): Observable<any> {
    return this.fileUploadService.postRequest(AppUrl.SINGLE_FILE_UPLOAD(), data);
  }

  updateProfileImage(data: {}): Observable<any> {
    return this.fileUploadService.postRequest(AppUrl.SINGLE_FILE_UPLOAD(), data);
  }

  makeFileRequestMultiple(params, event) {
    return this.fileUploadService.makeFileRequest(event, AppUrl.CHAT_FILE_UPLOAD(), params);
  }

}
